"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_TOKEN_PATH = exports.FIVE9_CLIENT = exports.AUTH_UI_CHAT_LOGIN_BASE_URL = exports.AUI_GENERIC_ERROR = exports.AUI_500_SERVICE_ERROR = exports.AUI_404_INVALID_HEADER = exports.AUI_403_UNTRUSTED_HOST = void 0;
var AUTH_UI_CHAT_LOGIN_BASE_URL = '/auth/chat-login';
exports.AUTH_UI_CHAT_LOGIN_BASE_URL = AUTH_UI_CHAT_LOGIN_BASE_URL;
var GET_TOKEN_PATH = '/get-token';
exports.GET_TOKEN_PATH = GET_TOKEN_PATH;
var FIVE9_CLIENT = 'CHAT_FIVE9';
exports.FIVE9_CLIENT = FIVE9_CLIENT;
var AUI_403_UNTRUSTED_HOST = 'AUI-403: Request host is not trusted by AUTH-UI.';
exports.AUI_403_UNTRUSTED_HOST = AUI_403_UNTRUSTED_HOST;
var AUI_404_INVALID_HEADER = 'AUI-404: Request header (janus token or client) is not valid.';
exports.AUI_404_INVALID_HEADER = AUI_404_INVALID_HEADER;
var AUI_500_SERVICE_ERROR = 'AUI-500: Server error from AUTH-UI.';
exports.AUI_500_SERVICE_ERROR = AUI_500_SERVICE_ERROR;
var AUI_GENERIC_ERROR = 'AUI-ERROR: Unexpected error occurred from AUTH-UI';
exports.AUI_GENERIC_ERROR = AUI_GENERIC_ERROR;
